// First paint uses the compiled build seed. Invalid or unavailable published
// bundles leave the last valid messages in place.
import englishSeed from '~/locales/en.json?raw';
import arabicSeed from '~/locales/ar.json?raw';
import { createTranslationRefresher } from '~/scripts/translation-bundle-validation.mjs';

export default defineNuxtPlugin((nuxtApp) => {
   const config = useRuntimeConfig();
   const stage = config.public.TRANSLATIONS_STAGE;
   const api = config.public.TRANSLATIONS_API;
   if (!stage || !api) return;

   const i18n = nuxtApp.$i18n as {
      locale: { value: string };
      setLocaleMessage: (locale: string, messages: object) => void;
   };
   let refresh: () => Promise<boolean>;
   try {
      refresh = createTranslationRefresher({
         api,
         stage,
         environment: stage,
         // Raw imports intentionally bypass the Vue locale precompiler: the
         // validator needs original parameter/plural grammar, not functions.
         seeds: { en: JSON.parse(englishSeed), ar: JSON.parse(arabicSeed) },
         getLocale: () => i18n.locale.value,
         applyMessages: (locale: string, messages: object) =>
            i18n.setLocaleMessage(locale, messages),
         // Browser-owned conditional caching needs no custom ETag/CORS headers.
         fetcher: (url: string) => fetch(url),
      });
   } catch {
      return;
   }

   nuxtApp.hook('app:mounted', () => {
      void refresh();
      watch(
         () => i18n.locale.value,
         () => {
            void refresh();
         },
      );
   });
});
